import { FieldErrors, UseFormRegister } from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";

interface IInputsDriveSystem {
  register: UseFormRegister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  onBlurHandler: (event: any) => void
}

function InputsDriveSystem(props: IInputsDriveSystem) {
  const { errors, register, onBlurHandler } = props;

  function atLeastOneChecked(formValues: any) {
    return formValues.driveSystemBelt ||
      formValues.driveSystemChain ||
      formValues.driveSystemLeadScrew ||
      formValues.driveSystemBallScrew
      ? true
      : false;
  }

  return (
    <>
      <div className="d-flex">
        <div>
          <div className="d-flex mr-25">
            <input
              type="checkbox"
              className={errors.driveSystemBelt ? "input-error-checkbox" : ""}
              {...register("driveSystemBelt", {
                validate: (value, formValues) => atLeastOneChecked(formValues),
                onBlur: onBlurHandler,
              })}
            />
            <p style={{ margin: "0px" }}>Belt</p>
          </div>
        </div>
        <div>
          <div className="d-flex mr-25">
            <input
              type="checkbox"
              className={errors.driveSystemChain ? "input-error-checkbox" : ""}
              {...register("driveSystemChain", {
                validate: (value, formValues) => atLeastOneChecked(formValues),
                onBlur: onBlurHandler,
              })}
            />
            <p style={{ margin: "0px" }}>Chain</p>
          </div>
        </div>
        <div>
          <div className="d-flex mr-25">
            <input
              type="checkbox"
              className={
                errors.driveSystemLeadScrew ? "input-error-checkbox" : ""
              }
              {...register("driveSystemLeadScrew", {
                validate: (value, formValues) => atLeastOneChecked(formValues),
                onBlur: onBlurHandler,
              })}
            />
            <p style={{ margin: "0px" }}>Lead Screw</p>
          </div>
        </div>
        <div>
          <div className="d-flex">
            <input
              type="checkbox"
              className={
                errors.driveSystemBallScrew ? "input-error-checkbox" : ""
              }
              {...register("driveSystemBallScrew", {
                validate: (value, formValues) => atLeastOneChecked(formValues),
                onBlur: onBlurHandler,
              })}
            />
            <p style={{ margin: "0px" }}>Ball Screw</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default InputsDriveSystem;
